import { render, staticRenderFns } from "./Readings.vue?vue&type=template&id=38099e6c&scoped=true"
import script from "./Readings.vue?vue&type=script&lang=js"
export * from "./Readings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38099e6c",
  null
  
)

export default component.exports